export default __webpack_public_path__ + "static/media/4-warranty.9b02642e.svg";